const RESERVED_SHOP_NAMES=new Set([
  'admin',
  'api',
  'app',
  'login',
  'register',
  's',
  'seller',
  'support',
  'www'
]);

const PREMIUM_PLANS=new Set([
  'premium',
  'premium_monthly',
  'monthly',
  'pro',
  'pro_monthly'
]);

export const normalizeShopUsername=(value='')=> (
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-]/g,'-')
    .replace(/-+/g,'-')
    .replace(/^-|-$/g,'')
    .slice(0,30)
);

export const isValidShopUsername=(value)=> (
  /^[a-z0-9](?:[a-z0-9-]{1,28}[a-z0-9])?$/.test(value) &&
  !RESERVED_SHOP_NAMES.has(value)
);

export const isPremiumSeller=(seller)=> {
  if (!seller) return false;

  const planValues=[
    seller.plan,
    seller.subscription_plan,
    seller.subscriptionPlan,
    seller.billing_plan,
    seller.billingPlan
  ]
    .filter(Boolean)
    .map(value=> String(value).trim().toLowerCase());

  return (
    seller.is_premium===true ||
    seller.premium===true ||
    seller.premium_flag===true ||
    seller.has_premium_flag===true ||
    planValues.some(plan=> PREMIUM_PLANS.has(plan))
  );
};

export const getShopUrl=(seller)=> {
  if (!seller?.shop_username) return null;

  const username=normalizeShopUsername(seller.shop_username);
  if (!username || !isValidShopUsername(username)) return null;

  if (isPremiumSeller(seller)) {
    return `https://${username}.sohlocal.shop`;
  }

  return `https://sohlocal.com/s/${username}`;
};